// The appointment note on a Week tile is a short label: its first three words, "…" after them when there is more
// (Antonin's export, `src/components/AppointmentTile/AppointmentTile.tsx` `shortNote`). The whole note is the tooltip.

/** The first three words of a note, "…" after them when there is more. Whitespace-only reads as empty. */
export function shortNote(note: string): string {
  const trimmed = note.trim();
  if (!trimmed) return '';
  const words = trimmed.split(/\s+/);
  return words.length <= 3 ? trimmed : `${words.slice(0, 3).join(' ')}…`;
}
